import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useAsyncCallback } from 'react-async-hook';
import { Form as SchemaForm, FieldError } from 'react-jsonschema-form-validation';
import {
	Alert,
	Button,
	Container,
	FormGroup,
} from 'reactstrap';
import ReactGA from 'react-ga';

import { FormLabel } from '../Form/Label';
import FormSubmit from '../Form/Submit';
import { getPasswordValidationMessage, schema } from './password.schema';
import FormPassword from '../Form/Password';

const initAccount = (initialState) => ({
	password: initialState.password || '',
});

export const LoginPassword = ({
	initialState,
	onBack,
	onSubmit,
}) => {
	const [account, setAccount] = useState(initAccount(initialState || {}));

	const handleSubmitAsync = useAsyncCallback(() => {
		ReactGA.event({ category: 'signup', action: 'password:next', label: 'User clicked on Create your account button in Signup Password step' });
		return onSubmit(account);
	}); //
	const { error } = handleSubmitAsync;
	if (error) console.error(error);

	const handleClickBack = useCallback(() => {
		ReactGA.event({ category: 'signup', action: 'password:back', label: 'User clicked on back button in Signup Password step' });
		return onBack(account);
	}, [onBack, account]);

	const handleChange = useCallback((data) => {
		handleSubmitAsync.reset();
		setAccount(data);
	}, [handleSubmitAsync]);

	useEffect(() => {
		setAccount((state) => ({ ...state, ...initAccount(initialState || {}) }));
	}, [initialState]);

	return (
		<Container fluid>
			<SchemaForm
				className="h-100 d-flex flex-column mt-4 mx-0 form-light"
				data={account}
				onChange={handleChange}
				onSubmit={handleSubmitAsync.execute}
				schema={schema}
			>
				<input onChange={() => {}} type="text" name="username" autoComplete="new-username" className="d-none" value={initialState.nickname} />
				<FormGroup className="mb-4">
					<FormLabel className="w-100">Password</FormLabel>
					<div className="text-muted mb-2">
						<small>
							* Password has to have at least one upper cased letter, one digit and one special sign
						</small>
					</div>
					<FormPassword autoComplete="new-password" name="password" value={account.password} />
					<FieldError
						name="password"
						errorMessages={{
							pattern: (data) => getPasswordValidationMessage(data.params.pattern) || data.message,
							minLength: () => 'Password must be at least 12 characters long',
						}}
					/>
				</FormGroup>
				<footer className="mt-auto">
					{error && (
						<Alert color="danger">
							An error occurred, please try again in a few minutes.
						</Alert>
					)}
					<div className="d-flex">
						<Button
							color="link"
							disabled={handleSubmitAsync.loading}
							onClick={handleClickBack}
						>
							back
						</Button>
						<FormSubmit
							className="ml-auto"
							loading={handleSubmitAsync.loading}
						>
							Create your account
						</FormSubmit>
					</div>
				</footer>
			</SchemaForm>
		</Container>
	);
};

LoginPassword.propTypes = {
	initialState: PropTypes.shape({
		nickname: PropTypes.string,
	}),
	onBack: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
};

LoginPassword.defaultProps = {
	initialState: {},
};
